// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.website-config-page {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
  background-color: var(--surface);
  min-height: 100%;
}

.wc-page-header h2 {
  margin: 0 0 6px;
  font-size: 22px;
  font-weight: 700;
  color: var(--text);
}

.wc-page-header p {
  margin: 0;
  color: var(--muted);
}

.wc-section {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 16px;
  padding: 22px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.wc-section h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: var(--text);
}

.wc-section-desc {
  margin: -10px 0 0;
  color: var(--muted);
  font-size: 13px;
  line-height: 1.5;
}

.wc-field-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.wc-row {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.wc-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: var(--text);
  font-size: 13px;
  font-weight: 500;
  flex: 1 1;
  min-width: 160px;
}

.championship-pit-stop-rules input:disabled {
  color: #64748b;
  background-color: #172033;
  border-color: #334155;
  opacity: 1;
  cursor: not-allowed;
}

.championship-pit-stop-rules input[type='checkbox']:disabled {
  accent-color: #475569;
  opacity: 0.45;
}

.championship-pit-stop-rules .form-group:has(input:disabled) label {
  color: #64748b;
}

/* ── File inputs ── */
.wc-field input[type='file'] {
  padding: 9px 12px;
  border-radius: 8px;
  border: 1px solid var(--border);
  background: var(--surface-strong);
  color: var(--text);
  font-size: 13px;
  cursor: pointer;
  width: 100%;
}

.wc-field input[type='file']::file-selector-button {
  padding: 4px 12px;
  border-radius: 6px;
  border: 1px solid var(--border);
  background: var(--surface);
  color: var(--text);
  cursor: pointer;
  font-size: 12px;
  margin-right: 10px;
  transition: background 0.15s;
}

.wc-field input[type='file']::file-selector-button:hover {
  background: var(--button-bg);
  color: #fff;
  border-color: var(--button-border);
}

/* ── Logo previews ── */
.wc-logo-previews {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
}

.wc-logo-card {
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 160px;
  max-width: 220px;
  flex: 1 1;
  background: var(--surface-strong);
}

.wc-logo-card span {
  font-size: 11px;
  color: var(--muted);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.wc-logo-card img {
  width: 100%;
  max-height: 100px;
  object-fit: contain;
  border-radius: 8px;
}

.wc-logo-light-bg { background: #f8fafc; }
.wc-logo-dark-bg  { background: #0f172a; }

.wc-favicon-preview {
  max-height: 48px !important;
  max-width: 48px !important;
  width: auto !important;
}

/* ── Color section header ── */
.wc-color-group {
  padding: 16px;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: var(--surface-strong);
}

.wc-color-section-label {
  font-size: 13px;
  font-weight: 600;
  color: var(--text);
}

/* ── Color swatches ── */
.wc-color-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 14px;
}

.wc-color-presets {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.wc-color-swatch {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid transparent;
  cursor: pointer;
  padding: 0;
  transition: transform 0.15s, box-shadow 0.15s;
  flex-shrink: 0;
}

.wc-color-swatch:hover { transform: scale(1.15); }

.wc-color-swatch.selected {
  border-color: var(--text);
  transform: scale(1.15);
  box-shadow: 0 0 0 2px var(--surface-strong), 0 0 0 4px currentColor;
}

/* ── Gradient swatches ── */
.wc-gradient-presets {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.wc-gradient-swatch {
  width: 56px;
  height: 28px;
  border-radius: 6px;
  border: 2px solid transparent;
  cursor: pointer;
  padding: 0;
  transition: transform 0.15s, box-shadow 0.15s;
}

.wc-gradient-swatch:hover { transform: scale(1.08); }

.wc-gradient-swatch.selected {
  border-color: var(--text);
  box-shadow: 0 0 0 2px var(--surface-strong);
}

.wc-gradient-custom-row {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

/* ── Native color input + label ── */
.wc-custom-color-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: var(--muted);
  cursor: pointer;
}

.wc-color-native {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: 1px solid var(--border);
  padding: 2px;
  background: var(--surface-strong);
  cursor: pointer;
}

.wc-color-hex {
  font-family: monospace;
  color: var(--text);
  font-size: 13px;
}

.wc-color-preview-bar {
  height: 6px;
  border-radius: 999px;
  width: 100%;
  transition: background 0.2s;
}

/* ── Rulebook ── */
.wc-rulebook-type-toggle {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.wc-type-btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 9px 16px;
  border-radius: 8px;
  border: 1px solid var(--border);
  background: var(--surface-strong);
  color: var(--muted-strong);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
}

.wc-type-btn:hover:not(.active) {
  border-color: var(--muted);
  color: var(--text);
}

.wc-type-btn.active {
  background: var(--button-bg);
  border-color: var(--button-border);
  color: #fff;
}

.wc-rulebook {
  width: 100%;
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid var(--border);
  background: var(--surface-strong);
  color: var(--text);
  font-size: 13px;
  line-height: 1.6;
  resize: vertical;
  box-sizing: border-box;
  font-family: 'Monaco', 'Menlo', 'Courier New', monospace;
}

.wc-rulebook:focus {
  outline: none;
  border-color: var(--button-border);
}

.wc-pdf-upload {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}

.wc-pdf-ready {
  font-size: 13px;
  color: var(--muted);
  font-style: italic;
}

/* ── Text input ── */
.wc-text-input {
  flex: 1 1;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid var(--border);
  background: var(--surface-strong);
  color: var(--text);
  font-size: 13px;
  font-family: inherit;
  width: 100%;
}

.wc-text-input:focus {
  outline: none;
  border-color: var(--button-border);
}

/* ── Broadcasting ── */
.wc-broadcast-row {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: flex-start;
}

.wc-platform-toggle {
  display: flex;
  gap: 10px;
}

.wc-platform-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 10px;
  border: 1px solid var(--border);
  background: var(--surface-strong);
  color: var(--muted-strong);
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
}

.wc-platform-btn.active {
  background: var(--button-bg);
  border-color: var(--button-border);
  color: #fff;
}

.wc-platform-btn:hover:not(.active) {
  border-color: var(--muted);
  color: var(--text);
}

.wc-channel-field { flex: 1 1; min-width: 240px; }

.wc-channel-input-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.wc-info-tip {
  color: var(--muted);
  cursor: help;
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

/* ── Page toggles ── */
.wc-page-toggles {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.wc-toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-radius: 10px;
  border: 1px solid var(--border);
  background: var(--surface-strong);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.wc-toggle-label {
  font-size: 14px;
  color: var(--text);
  font-weight: 500;
}

.wc-toggle-label-group {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.wc-toggle-sublabel {
  font-size: 12px;
  color: var(--muted);
  font-weight: 400;
}

.wc-toggle {
  position: relative;
  width: 44px;
  height: 24px;
  border-radius: 999px;
  border: none;
  background: var(--border);
  cursor: pointer;
  transition: background 0.2s;
  padding: 0;
  flex-shrink: 0;
}

.wc-toggle.on { background: var(--button-bg); }

.wc-toggle-thumb {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: white;
  transition: transform 0.2s;
  display: block;
}

.wc-toggle.on .wc-toggle-thumb { transform: translateX(20px); }

/* ── Save row ── */
.wc-instructions {
  margin: 12px 0 16px;
  background: var(--surface-strong, rgba(255,255,255,0.04));
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 0.85rem;
}

.wc-instructions summary {
  cursor: pointer;
  font-weight: 500;
  color: var(--muted-strong, #cbd5e1);
  -webkit-user-select: none;
          user-select: none;
}

.wc-instructions-list {
  margin: 10px 0 4px;
  padding-left: 20px;
  line-height: 1.7;
  color: var(--muted-text, #94a3b8);
}

.wc-instructions-list code {
  background: var(--surface-strong, rgba(255,255,255,0.08));
  padding: 1px 5px;
  border-radius: 4px;
  font-family: monospace;
  font-size: 0.8em;
}

.wc-save-row {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}

.wc-save-feedback {
  color: var(--muted-strong);
  font-size: 13px;
}
`, "",{"version":3,"sources":["webpack://./src/components/WebsiteConfig.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,WAAW;EACX,kCAAkC;AACpC;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,SAAO;EACP,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,oBAAoB,mBAAmB,EAAE;AACzC,oBAAoB,mBAAmB,EAAE;;AAEzC;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,UAAU;EACV,6CAA6C;EAC7C,cAAc;AAChB;;AAEA,yBAAyB,sBAAsB,EAAE;;AAEjD;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mEAAmE;AACrE;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,UAAU;EACV,6CAA6C;AAC/C;;AAEA,4BAA4B,sBAAsB,EAAE;;AAEpD;EACE,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,YAAY;EACZ,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,WAAW;EACX,2BAA2B;AAC7B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,iCAAiC;EACjC,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6DAA6D;AAC/D;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,SAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,iCAAiC;EACjC,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,6DAA6D;AAC/D;;AAEA;EACE,4BAA4B;EAC5B,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA,oBAAoB,SAAO,EAAE,gBAAgB,EAAE;;AAE/C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,iCAAiC;EACjC,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,2BAA2B;EAC3B,UAAU;EACV,cAAc;AAChB;;AAEA,gBAAgB,4BAA4B,EAAE;;AAE9C;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA,iCAAiC,2BAA2B,EAAE;;AAE9D,mBAAmB;AACnB;EACE,mBAAmB;EACnB,yDAAyD;EACzD,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yDAAyD;EACzD,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB","sourcesContent":[".website-config-page {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 24px;\r\n  padding: 24px;\r\n  background-color: var(--surface);\r\n  min-height: 100%;\r\n}\r\n\r\n.wc-page-header h2 {\r\n  margin: 0 0 6px;\r\n  font-size: 22px;\r\n  font-weight: 700;\r\n  color: var(--text);\r\n}\r\n\r\n.wc-page-header p {\r\n  margin: 0;\r\n  color: var(--muted);\r\n}\r\n\r\n.wc-section {\r\n  background: var(--surface);\r\n  border: 1px solid var(--border);\r\n  border-radius: 16px;\r\n  padding: 22px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 18px;\r\n}\r\n\r\n.wc-section h3 {\r\n  margin: 0;\r\n  font-size: 15px;\r\n  font-weight: 700;\r\n  color: var(--text);\r\n}\r\n\r\n.wc-section-desc {\r\n  margin: -10px 0 0;\r\n  color: var(--muted);\r\n  font-size: 13px;\r\n  line-height: 1.5;\r\n}\r\n\r\n.wc-field-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n.wc-row {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 16px;\r\n}\r\n\r\n.wc-field {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  color: var(--text);\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  flex: 1;\r\n  min-width: 160px;\r\n}\r\n\r\n.championship-pit-stop-rules input:disabled {\r\n  color: #64748b;\r\n  background-color: #172033;\r\n  border-color: #334155;\r\n  opacity: 1;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.championship-pit-stop-rules input[type='checkbox']:disabled {\r\n  accent-color: #475569;\r\n  opacity: 0.45;\r\n}\r\n\r\n.championship-pit-stop-rules .form-group:has(input:disabled) label {\r\n  color: #64748b;\r\n}\r\n\r\n/* ── File inputs ── */\r\n.wc-field input[type='file'] {\r\n  padding: 9px 12px;\r\n  border-radius: 8px;\r\n  border: 1px solid var(--border);\r\n  background: var(--surface-strong);\r\n  color: var(--text);\r\n  font-size: 13px;\r\n  cursor: pointer;\r\n  width: 100%;\r\n}\r\n\r\n.wc-field input[type='file']::file-selector-button {\r\n  padding: 4px 12px;\r\n  border-radius: 6px;\r\n  border: 1px solid var(--border);\r\n  background: var(--surface);\r\n  color: var(--text);\r\n  cursor: pointer;\r\n  font-size: 12px;\r\n  margin-right: 10px;\r\n  transition: background 0.15s;\r\n}\r\n\r\n.wc-field input[type='file']::file-selector-button:hover {\r\n  background: var(--button-bg);\r\n  color: #fff;\r\n  border-color: var(--button-border);\r\n}\r\n\r\n/* ── Logo previews ── */\r\n.wc-logo-previews {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 14px;\r\n}\r\n\r\n.wc-logo-card {\r\n  border: 1px solid var(--border);\r\n  border-radius: 12px;\r\n  padding: 12px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  min-width: 160px;\r\n  max-width: 220px;\r\n  flex: 1;\r\n  background: var(--surface-strong);\r\n}\r\n\r\n.wc-logo-card span {\r\n  font-size: 11px;\r\n  color: var(--muted);\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n}\r\n\r\n.wc-logo-card img {\r\n  width: 100%;\r\n  max-height: 100px;\r\n  object-fit: contain;\r\n  border-radius: 8px;\r\n}\r\n\r\n.wc-logo-light-bg { background: #f8fafc; }\r\n.wc-logo-dark-bg  { background: #0f172a; }\r\n\r\n.wc-favicon-preview {\r\n  max-height: 48px !important;\r\n  max-width: 48px !important;\r\n  width: auto !important;\r\n}\r\n\r\n/* ── Color section header ── */\r\n.wc-color-group {\r\n  padding: 16px;\r\n  border: 1px solid var(--border);\r\n  border-radius: 12px;\r\n  background: var(--surface-strong);\r\n}\r\n\r\n.wc-color-section-label {\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: var(--text);\r\n}\r\n\r\n/* ── Color swatches ── */\r\n.wc-color-row {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  gap: 14px;\r\n}\r\n\r\n.wc-color-presets {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n}\r\n\r\n.wc-color-swatch {\r\n  width: 28px;\r\n  height: 28px;\r\n  border-radius: 50%;\r\n  border: 2px solid transparent;\r\n  cursor: pointer;\r\n  padding: 0;\r\n  transition: transform 0.15s, box-shadow 0.15s;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.wc-color-swatch:hover { transform: scale(1.15); }\r\n\r\n.wc-color-swatch.selected {\r\n  border-color: var(--text);\r\n  transform: scale(1.15);\r\n  box-shadow: 0 0 0 2px var(--surface-strong), 0 0 0 4px currentColor;\r\n}\r\n\r\n/* ── Gradient swatches ── */\r\n.wc-gradient-presets {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n}\r\n\r\n.wc-gradient-swatch {\r\n  width: 56px;\r\n  height: 28px;\r\n  border-radius: 6px;\r\n  border: 2px solid transparent;\r\n  cursor: pointer;\r\n  padding: 0;\r\n  transition: transform 0.15s, box-shadow 0.15s;\r\n}\r\n\r\n.wc-gradient-swatch:hover { transform: scale(1.08); }\r\n\r\n.wc-gradient-swatch.selected {\r\n  border-color: var(--text);\r\n  box-shadow: 0 0 0 2px var(--surface-strong);\r\n}\r\n\r\n.wc-gradient-custom-row {\r\n  display: flex;\r\n  gap: 16px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n/* ── Native color input + label ── */\r\n.wc-custom-color-label {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  font-size: 13px;\r\n  color: var(--muted);\r\n  cursor: pointer;\r\n}\r\n\r\n.wc-color-native {\r\n  width: 36px;\r\n  height: 36px;\r\n  border-radius: 8px;\r\n  border: 1px solid var(--border);\r\n  padding: 2px;\r\n  background: var(--surface-strong);\r\n  cursor: pointer;\r\n}\r\n\r\n.wc-color-hex {\r\n  font-family: monospace;\r\n  color: var(--text);\r\n  font-size: 13px;\r\n}\r\n\r\n.wc-color-preview-bar {\r\n  height: 6px;\r\n  border-radius: 999px;\r\n  width: 100%;\r\n  transition: background 0.2s;\r\n}\r\n\r\n/* ── Rulebook ── */\r\n.wc-rulebook-type-toggle {\r\n  display: flex;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.wc-type-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n  padding: 9px 16px;\r\n  border-radius: 8px;\r\n  border: 1px solid var(--border);\r\n  background: var(--surface-strong);\r\n  color: var(--muted-strong);\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: background 0.15s, color 0.15s, border-color 0.15s;\r\n}\r\n\r\n.wc-type-btn:hover:not(.active) {\r\n  border-color: var(--muted);\r\n  color: var(--text);\r\n}\r\n\r\n.wc-type-btn.active {\r\n  background: var(--button-bg);\r\n  border-color: var(--button-border);\r\n  color: #fff;\r\n}\r\n\r\n.wc-rulebook {\r\n  width: 100%;\r\n  padding: 12px 14px;\r\n  border-radius: 10px;\r\n  border: 1px solid var(--border);\r\n  background: var(--surface-strong);\r\n  color: var(--text);\r\n  font-size: 13px;\r\n  line-height: 1.6;\r\n  resize: vertical;\r\n  box-sizing: border-box;\r\n  font-family: 'Monaco', 'Menlo', 'Courier New', monospace;\r\n}\r\n\r\n.wc-rulebook:focus {\r\n  outline: none;\r\n  border-color: var(--button-border);\r\n}\r\n\r\n.wc-pdf-upload {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 14px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.wc-pdf-ready {\r\n  font-size: 13px;\r\n  color: var(--muted);\r\n  font-style: italic;\r\n}\r\n\r\n/* ── Text input ── */\r\n.wc-text-input {\r\n  flex: 1;\r\n  padding: 10px 12px;\r\n  border-radius: 8px;\r\n  border: 1px solid var(--border);\r\n  background: var(--surface-strong);\r\n  color: var(--text);\r\n  font-size: 13px;\r\n  font-family: inherit;\r\n  width: 100%;\r\n}\r\n\r\n.wc-text-input:focus {\r\n  outline: none;\r\n  border-color: var(--button-border);\r\n}\r\n\r\n/* ── Broadcasting ── */\r\n.wc-broadcast-row {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 16px;\r\n  align-items: flex-start;\r\n}\r\n\r\n.wc-platform-toggle {\r\n  display: flex;\r\n  gap: 10px;\r\n}\r\n\r\n.wc-platform-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 10px 16px;\r\n  border-radius: 10px;\r\n  border: 1px solid var(--border);\r\n  background: var(--surface-strong);\r\n  color: var(--muted-strong);\r\n  cursor: pointer;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  transition: background 0.15s, border-color 0.15s, color 0.15s;\r\n}\r\n\r\n.wc-platform-btn.active {\r\n  background: var(--button-bg);\r\n  border-color: var(--button-border);\r\n  color: #fff;\r\n}\r\n\r\n.wc-platform-btn:hover:not(.active) {\r\n  border-color: var(--muted);\r\n  color: var(--text);\r\n}\r\n\r\n.wc-channel-field { flex: 1; min-width: 240px; }\r\n\r\n.wc-channel-input-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.wc-info-tip {\r\n  color: var(--muted);\r\n  cursor: help;\r\n  flex-shrink: 0;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n/* ── Page toggles ── */\r\n.wc-page-toggles {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n.wc-toggle-row {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 12px 16px;\r\n  border-radius: 10px;\r\n  border: 1px solid var(--border);\r\n  background: var(--surface-strong);\r\n  cursor: pointer;\r\n  user-select: none;\r\n}\r\n\r\n.wc-toggle-label {\r\n  font-size: 14px;\r\n  color: var(--text);\r\n  font-weight: 500;\r\n}\r\n\r\n.wc-toggle-label-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n}\r\n\r\n.wc-toggle-sublabel {\r\n  font-size: 12px;\r\n  color: var(--muted);\r\n  font-weight: 400;\r\n}\r\n\r\n.wc-toggle {\r\n  position: relative;\r\n  width: 44px;\r\n  height: 24px;\r\n  border-radius: 999px;\r\n  border: none;\r\n  background: var(--border);\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n  padding: 0;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.wc-toggle.on { background: var(--button-bg); }\r\n\r\n.wc-toggle-thumb {\r\n  position: absolute;\r\n  top: 3px;\r\n  left: 3px;\r\n  width: 18px;\r\n  height: 18px;\r\n  border-radius: 50%;\r\n  background: white;\r\n  transition: transform 0.2s;\r\n  display: block;\r\n}\r\n\r\n.wc-toggle.on .wc-toggle-thumb { transform: translateX(20px); }\r\n\r\n/* ── Save row ── */\r\n.wc-instructions {\r\n  margin: 12px 0 16px;\r\n  background: var(--surface-strong, rgba(255,255,255,0.04));\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 8px;\r\n  padding: 10px 14px;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.wc-instructions summary {\r\n  cursor: pointer;\r\n  font-weight: 500;\r\n  color: var(--muted-strong, #cbd5e1);\r\n  user-select: none;\r\n}\r\n\r\n.wc-instructions-list {\r\n  margin: 10px 0 4px;\r\n  padding-left: 20px;\r\n  line-height: 1.7;\r\n  color: var(--muted-text, #94a3b8);\r\n}\r\n\r\n.wc-instructions-list code {\r\n  background: var(--surface-strong, rgba(255,255,255,0.08));\r\n  padding: 1px 5px;\r\n  border-radius: 4px;\r\n  font-family: monospace;\r\n  font-size: 0.8em;\r\n}\r\n\r\n.wc-save-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 14px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.wc-save-feedback {\r\n  color: var(--muted-strong);\r\n  font-size: 13px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
